import { Translation } from '@deaf-bible-society-2-0/deafbible-metadata-utils';

import twcbtChineseTitles from '../data/twcbt_chinese_titles';

const fixASLCBT = (data: Translation): Translation => {
  const clonedData = JSON.parse(JSON.stringify(data)) as Translation;

  clonedData.stories.forEach(story => {
    const { videos } = story;

    // eslint-disable-next-line no-param-reassign
    story.videos = videos.filter(
      video => video.type === 'intro-passage' || video.type === 'intro-passage-moreinfo'
    );
  });

  return clonedData;
};

export const fixTWCBT = (data: Translation): Translation => {
  const clonedData = JSON.parse(JSON.stringify(data)) as Translation;

  clonedData.stories.forEach(story => {
    const englishTitle = story.title_english || story.title || '';
    const numberMatch = englishTitle.match(/^(\d+)\./);
    const order = numberMatch ? Number(numberMatch[1]) : story.display_order;
    const chineseTitle = twcbtChineseTitles[order];

    if (chineseTitle) {
      // eslint-disable-next-line no-param-reassign
      story.title = chineseTitle;
      // eslint-disable-next-line no-param-reassign
      story.title_english = englishTitle;
    }
  });

  return clonedData;
};

export default fixASLCBT;
